import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useAccountsQuery, useAlignAllCartDatesMutation } from "../../Generated/graphql";
import { AccountListItem } from "../AccountListItem/AccountListItem";
import { BoxLoader } from "../BoxLoader/BoxLoader";
import { Button } from "../Button/Button";
import { toast } from "react-toastify";
import "./SuperAdminAccounts.css";

export const SuperAdminAccounts = () => {
  const history = useHistory();
  const { data, error, loading } = useAccountsQuery();
  const [alignCartDates, { loading: aligning }] = useAlignAllCartDatesMutation();
  const [isAligning, setIsAligning] = useState(false);

  const handleAlignCartDates = async () => {
    setIsAligning(true);
    try {
      const result = await alignCartDates();
      const count = result.data?.alignAllCartDates || 0;
      toast.success(`${count} kurve blev opdateret til næste gyldige ordredato`);
    } catch (err) {
      toast.error("Fejl ved opdatering af kurve datoer");
    } finally {
      setIsAligning(false);
    }
  };

  return (
    <div className="SuperAdmin__accountslist">
      <div className="SuperAdmin__accountslist__title">
        <div className="SuperAdmin__accountslist__title-text">Alle konti</div>
      </div>
      <div className="Settings__dividerbar"></div>
      <div className="SuperAdmin__newaccount">
        <div className="SuperAdmin__newaccount-button">
          <Button
            buttonStyle="newItem"
            click={() => {
              history.push("/superadmin/accounts/new");
            }}
          >
            Tilføj konto
          </Button>
        </div>
        <div className="SuperAdmin__newaccount-button" style={{ marginLeft: "10px" }}>
          <Button
            buttonStyle="newItem"
            click={handleAlignCartDates}
            inactive={isAligning || aligning}
          >
            {isAligning || aligning ? "Opdaterer..." : "Juster kurve datoer"}
          </Button>
        </div>
      </div>

      <div className="SuperAdmin__accounts">
        {loading && <BoxLoader />}
        {error && <div>{error.message}</div>}
        {data?.accounts.map((account) => {
          return <AccountListItem key={account.id} account={account} />;
        })}
      </div>
    </div>
  );
};
